import React from "react";
import Box from "@mui/material/Box";
import Splash from "../components/splash/Splash";
import ProductTile from "../components/product-tile/ProductTile";
import { Alert, Container, Tab, Tabs } from "@mui/material";
import { a11yProps } from "../../pages/orders/functions";
import { theme } from "../../../components/special/genie-theme/genie-theme";
import { useParams } from "react-router-dom";
import ProductTileLoad from "../components/product-tile/ProductTileLoad";
import useForSale from "../../../queries/routes/useForSale";
import { TabPanel } from "../pdp/TabPanel";
import useUser from "../../../queries/routes/useUser";
// import useBuyerOrders from "../../../queries/routes/useBuyerOrders";
import useOrderTerms from "../../../queries/routes/useOrderTerms";
import useOrdersForCustomer from "../../../queries/routes/useOrdersForCustomer";
import { formatCurrency } from "../../../utils/currency";

function Catalog() {
  const [tab, setTab] = React.useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };
  const { org_id } = useParams();
  const { data: user } = useUser();
  const { data, isLoading } = useForSale(org_id!);

  // Get order terms for the specific organization
  const { data: orderTerms } = useOrderTerms(org_id);

  // Get orders between the current user's organization and the selling organization
  const { data: customerOrders } = useOrdersForCustomer(org_id!, user?.organizations[0]?.id!);

  if (!data) {
    return null;
  }

  return (
    <>
      <Splash />
      <Box sx={{ mt: "136px", mb: 5, borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          centered
          value={tab}
          onChange={handleTabChange}
          aria-label="catalog-terms-tab"
        >
          <Tab label="Catalog" {...a11yProps(0)} />
          <Tab label="Terms" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Container maxWidth="md" sx={{ p: 0 }}>
        <TabPanel value={tab} index={0}>
          <Box
            display={"grid"}
            sx={{
              rowGap: 4,
              columnGap: 2,
              gridTemplateColumns: "1fr 1fr 1fr",
              mb: 4,
              [theme.breakpoints.down("md")]: {
                gridTemplateColumns: "1fr 1fr",
              },
            }}
          >
            {!data || isLoading ? (
              <>
                <ProductTileLoad />
                <ProductTileLoad />
                <ProductTileLoad />
                <ProductTileLoad />
                <ProductTileLoad />
                <ProductTileLoad />
              </>
            ) : (
              data.map((product) => {
                return <ProductTile key={product.id} product={product} />;
              })
            )}
          </Box>
        </TabPanel>
          <TabPanel value={tab} index={1}>
            {!customerOrders || customerOrders.length === 0 ? (
              <>
                {!!orderTerms?.new_customer_min && (
                  <Alert>
                    The minimum order quantity for your first order is{" "}
                    {orderTerms?.new_customer_min} units.
                  </Alert>
                )}
                {!!orderTerms?.new_customer_min_cents && (
                  <Alert sx={{ mt: 2 }}>
                    The minimum order amount for your first order is{" "}
                    {formatCurrency(orderTerms?.new_customer_min_cents)}.
                  </Alert>
                )}
              </>
            ) : (
              <>
                {!!orderTerms?.returning_customer_min && (
                  <Alert>
                    The minimum order quantity for returning customers is{" "}
                    {orderTerms?.returning_customer_min} units.
                  </Alert>
                )}
                {!!orderTerms?.returning_customer_min_cents && (
                  <Alert sx={{ mt: 2 }}>
                    The minimum order amount for your order is{" "}
                    {formatCurrency(orderTerms?.returning_customer_min_cents)}.
                  </Alert>
                )}
              </>
            )}
          </TabPanel>
      </Container>
    </>
  );
}

export default Catalog;
